import { TableRow, TableCell, Skeleton } from "@mui/material";
import { TableBody } from "@mui/material";
import { DataTable } from "~/components/data-table/data-table";
import { TableHead } from "~/pages/inventory/components/TableHead";
import { Flex } from "~/components/Flex";
import { SECURITY_PIPELINE_GITHUB_WORKFLOWS_TABLE_HEADERS } from "./constants";

export const SecurityPipelineGithubWorkflowsTableSkeleton = () => {
  return (
    <Flex flexDirection="column" gap={2}>
      <DataTable id="activity-history-table">
        <TableHead
          tableHeaders={SECURITY_PIPELINE_GITHUB_WORKFLOWS_TABLE_HEADERS}
        />
        <TableBody>
          {Array.from({ length: 5 }).map((_, index) => (
            <TableRow key={index}>
              <TableCell>
                <Skeleton variant="text" width="60%" animation="wave" />
              </TableCell>
              <TableCell>
                <Skeleton variant="text" width="40%" animation="wave" />
              </TableCell>
              <TableCell>
                <Skeleton variant="text" width="30%" animation="wave" />
              </TableCell>
              <TableCell>
                <Skeleton
                  variant="rounded"
                  width={80}
                  height={24}
                  animation="wave"
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </DataTable>
      <Skeleton variant="rounded" width="100%" height={32} animation="wave" />
    </Flex>
  );
};
